module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAA2ElEQVQoka2SsQrCMBCGMzgoKK6dBfcOfZWOhVC4/2jmzqEvIDi4uPSJujiYwcWxmz5Ah7o0JU1TXfzhIHD/Ry7/RQhPzHxk5g5AP1RXFMXB900E4OoAk2Lm0xK0X4JsKaW2IfBpDcaY3soY4976CIGjwZfb+yt4t02t9QhprV3wNgPzPN/9CidN000wWSLKliAiyoKQlHJNRDGAOgDWRBRLKdcjwMyJt6uImRtnBY1SKvI+QyJCY1VVtQLwBvAazjOPAHAJNgJrct57doMpAbRfUm2JqLT+D+JhO8k62r3gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/images/icon_dz.png
// module id = 82c6
// module chunks = 2